<div class="history-container">
  <div class="history-actions">
    <button mat-flat-button color="primary" class="new-chat-btn" (click)="createNew.emit()">
      <mat-icon fontIcon="add"></mat-icon>
      <span>New chat</span>
    </button>
  </div>

  <div class="history-label" *ngIf="sessions.length">Recent</div>

  <div class="history-list" *ngIf="sessions.length; else emptyState">
    <div
      class="history-item"
      *ngFor="let session of sessions; trackBy: trackBySessionId"
      [class.active]="session.id === activeSessionId"
      (click)="sessionSelected.emit(session.id)"
      tabindex="0"
      role="button"
      (keydown.enter)="sessionSelected.emit(session.id)"
    >
      <mat-icon class="item-icon" fontIcon="chat_bubble_outline"></mat-icon>
      <div class="item-content">
        <div class="item-title">{{ titlePreview(session.title) }}</div>
        <div class="item-date">{{ session.updatedAt | date: 'MMM d' }}</div>
      </div>
      
      <button
        mat-icon-button
        class="item-menu-btn"
        [matMenuTriggerFor]="historyMenu"
        [matMenuTriggerData]="{ session: session }"
        (click)="$event.stopPropagation()"
        aria-label="Session options"
      >
        <mat-icon fontIcon="more_vert"></mat-icon>
      </button>
    </div>
  </div>

  <mat-menu #historyMenu="matMenu">
    <ng-template matMenuContent let-session="session">
      <button mat-menu-item (click)="deleteSession.emit(session.id)">
        <mat-icon fontIcon="delete_outline"></mat-icon>
        <span>Delete conversation</span>
      </button>
    </ng-template>
  </mat-menu>

  <ng-template #emptyState>
    <div class="empty-state">
      <div class="empty-icon">
        <mat-icon fontIcon="forum"></mat-icon>
      </div>
      <p class="empty-text">No chat history</p>
      <p class="empty-sub">Start a new conversation to get help.</p>
    </div>
  </ng-template>
</div>
